const login = {
  name: "login",
  path: "/login",
  component: () => import("@/views/register/LoginView.vue"),
};

export default login;
